module.exports = __webpack_public_path__ + "static/media/card-readerImg.03fd471d.png";